import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b9ebadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gg-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill row center h2" }, "Edit booking", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_7 = { class: "items row col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "You are editing", -1))
const _hoisted_9 = { class: "h1" }
const _hoisted_10 = {
  key: 0,
  class: "h4 gray"
}
const _hoisted_11 = {
  key: 1,
  class: "h4 gray"
}
const _hoisted_12 = {
  key: 2,
  class: "h4 gray"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_14 = { class: "scroll row col gap" }
const _hoisted_15 = {
  key: 0,
  class: "loading-box"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "times"
}
const _hoisted_18 = { class: "row v-center" }
const _hoisted_19 = { class: "row col sm-gap" }
const _hoisted_20 = { class: "bold row v-center" }
const _hoisted_21 = {
  key: 0,
  class: "box"
}
const _hoisted_22 = { class: "price" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gg-arrow-up" }),
  /*#__PURE__*/_createElementVNode("div", { class: "gg-arrow-down" })
], -1))
const _hoisted_24 = {
  key: 0,
  class: "wide"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gg-check" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "small"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray row center v-center sm-gap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gg-info" }),
  /*#__PURE__*/_createTextVNode(" This date has no availability, please select another ")
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_36 = { class: "row spaced" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gg-chevron-left" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_section = _resolveComponent("date-section")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _hoisted_4),
      _hoisted_5
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.activity?.name), 1),
      (_ctx.activityDateString)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.activityDateString), 1))
        : _createCommentVNode("", true),
      (!!_ctx.time?.Rates.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.rates), 1))
        : _createCommentVNode("", true),
      (_ctx.addons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.addons), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_date_section),
      (_ctx.loading || _ctx.getTimesLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_loader_display)
          ]))
        : (_ctx.time?.AppointmentTypeKey == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_ctx.activity?.availableTimes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity?.availableTimes, (time) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: time.DisplayName ?? -1,
                        class: _normalizeClass(["row spaced gap v-center time", { selected: _ctx.selected(time) }])
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createTextVNode(_toDisplayString(time.DisplayName) + " ", 1),
                              (time.Description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(time.Description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["time-details", _ctx.priceClass(time)])
                            }, [
                              _createTextVNode(" Subtotal: "),
                              _createVNode(_component_si_currency, {
                                amount: time.SubTotal,
                                class: "pad-right"
                              }, null, 8, ["amount"]),
                              _createElementVNode("div", _hoisted_22, [
                                _createTextVNode(" ("),
                                _createVNode(_component_si_currency, {
                                  amount: _ctx.priceDifference(time)
                                }, null, 8, ["amount"]),
                                _hoisted_23,
                                _createTextVNode(" ) ")
                              ]),
                              _createTextVNode(" • " + _toDisplayString(time.TotalAvailable) + " spot" + _toDisplayString(time.TotalAvailable == 1 ? '' : 's') + " available ", 1)
                            ], 2)
                          ])
                        ]),
                        (_ctx.selected(time))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                          : (time?.CallToBook)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createTextVNode(" To book this time, please call us at "),
                                _createElementVNode("a", {
                                  href: `tel:${_ctx.phoneNumber}`
                                }, _toDisplayString(_ctx.phoneNumber), 9, _hoisted_28)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("button", {
                                  class: "blue",
                                  onClick: ($event: any) => (_ctx.book(time))
                                }, "Book", 8, _hoisted_30)
                              ]))
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_31, "No times available"))
            ]))
          : (!_ctx.activity?.availableTimes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
            : _createCommentVNode("", true)
    ]),
    _hoisted_35,
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("button", {
        class: "row v-center gray",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, [
        _hoisted_37,
        _createTextVNode(" Back")
      ]),
      (_ctx.time?.AppointmentTypeKey == 2)
        ? (_openBlock(), _createBlock(_component_progress_button, {
            key: 0,
            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTime())),
            disabled: !_ctx.canSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Continue ")
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}